import { Color, Scene } from "three";

import type { WorldObjectAPI } from "./WorldObject";

export class World {
  readonly scene = new Scene();
  private readonly objects = new Set<WorldObjectAPI>();

  setBackgroundColor(color: string) {
    this.scene.background = new Color(color);
  }

  add(object: WorldObjectAPI) {
    this.objects.add(object);
    this.scene.add(object.root);
  }

  removeAndDispose(object: WorldObjectAPI) {
    if (!this.objects.delete(object)) return;
    this.scene.remove(object.root);
    object.dispose();
  }

  getObjects(): ReadonlySet<WorldObjectAPI> {
    return this.objects;
  }

  step(deltaSeconds: number) {
    for (const object of this.objects) object.step?.(deltaSeconds);
  }

  dispose() {
    for (const object of this.objects) this.removeAndDispose(object);
  }
}
